import styled from 'styled-components';
import TextField from '@mui/material/TextField';

export const TextFieldStyled = styled(TextField)``;
